// const setViewportHeight = ( () => {
// 	function init() {
// 		// window.addEventListener('resize', () => {
// 		//     setHeight()
// 		// })
// 		window.addEventListener( 'DOMContentLoaded', () => {
// 			setHeight();
// 		} );
// 	}

// 	function setHeight() {
// 		const vh = window.innerHeight * 0.01;
// 		document.documentElement.style.setProperty( '--vh', `${ vh }px` );
// 	}

// 	return {
// 		init,
// 	};
// } )();

function setViewportHeight() {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

export default setViewportHeight;
